module.exports = __webpack_public_path__ + "static/media/Commerce.73f384f1.svg";